module.exports = __webpack_public_path__ + "static/img/sqs.40811475.jpg";